import { render, staticRenderFns } from "./audio.vue?vue&type=template&id=04420336&scoped=true"
import script from "./audio.vue?vue&type=script&lang=js"
export * from "./audio.vue?vue&type=script&lang=js"
import style0 from "./audio.vue?vue&type=style&index=0&id=04420336&prod&lang=css"
import style1 from "./audio.vue?vue&type=style&index=1&id=04420336&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04420336",
  null
  
)

export default component.exports